import axios from "axios";
import { AddDependentModel, AddEducationQualificationModel, AddEmployeeLicensesModel, AddEmployeeSkillModel, AddEmployeeSupervisorModel } from "../../../modules/accounts/components/settings/SettingsModel";
import secureLocalStorage from "react-secure-storage";
const baseURL = secureLocalStorage.getItem("baseURL");
// List of Genders
export const get_all_genders = async () => {
    let response = await axios.get(baseURL + "/api/gender");
    return response.data;
  }
  // List of Active Roles
export const get_all_active_roles = async () => {
  let response = await axios.get(baseURL + "/api/active-roles");
  return response.data;
}
 // List of Active Departments
 export const get_all_active_department = async () => {
  let response = await axios.get(baseURL + "/api/active-departments");
  return response.data;
}
 // List of Active Countries
 export const get_all_active_countries = async () => {
  let response = await axios.get(baseURL + "/api/get-active-countries");
  return response.data;
}
// List of Active Relationships
export const get_all_active_relationships = async () => {
  let response = await axios.get(baseURL + "/api/active-relationships");
  return response.data;
}
// List of Active Leave types
export const get_all_active_leave_type = async () => {
  let response = await axios.get(baseURL + "/api/get-active-leave-types");
  return response.data;
}
// List of Active Designation
export const get_all_active_designation = async () => {
  let response = await axios.get(baseURL + "/api/get-active-designations");
  return response.data;
}
// List of Active Job Categories
export const get_all_active_job_categories = async () => {
  let response = await axios.get(baseURL + "/api/active-job-categories");
  return response.data;
}
// List of Active Salary Components
export const get_all_active_salary_components = async () => {
  let response = await axios.get(baseURL + "/api/get-active-salary-components");
  return response.data;
}
// List of Active Pay Grades
export const get_all_active_pay_grades= async () => {
  let response = await axios.get(baseURL + "/api/get-active-pay-grades");
  return response.data;
}
// List of Active Currencies
export const get_all_active_currencies= async () => {
  let response = await axios.get(baseURL + "/api/active-currencies");
  return response.data;
}
// List of Active Reporting Methods
export const get_all_active_reporting_methods= async () => {
  let response = await axios.get(baseURL + "/api/get-active-reporting-methods");
  return response.data;
}
// List of Active Education Levels
export const get_all_active_education_levels= async () => {
  let response = await axios.get(baseURL + "/api/get-active-education-levels");
  return response.data;
}
// List of Active Languages
export const get_all_active_languages= async () => {
  let response = await axios.get(baseURL + "/api/active-languages");
  return response.data;
}
// List of Active Language Competencies
export const get_all_active_language_competencies= async () => {
  let response = await axios.get(baseURL + "/api/active-language-competencies");
  return response.data;
}
// List of Active Reasons for Leaving
export const get_all_active_reason_for_leaving = async () => {
  let response = await axios.get(`${baseURL}/api/active-reason-for-leavings`);
  return response.data;
}
// List of Active Attendance Type
export const get_all_active_attendance_type= async () => {
  let response = await axios.get(`${secureLocalStorage.getItem("baseURL")}/api/active-attendance-type`);
  return response.data;
}
// List of Active active-type-of-assets
export const get_all_active_type_of_assets= async () => {
  let response = await axios.get(`${baseURL}/api/active-type-of-assets`);
  return response.data;
}
// List of Active Language Fluencies
export const get_all_active_language_fluencies= async () => {
  let response = await axios.get(baseURL + "/api/active-language-fluencies");
  return response.data;
}
// List of Active Employment Status
export const get_all_active_employment_status= async () => {
  let response = await axios.get(baseURL + "/api/active-employment-status");
  return response.data;
}
// List of Active Job Titles
export const get_all_active_job_titles = async () => {
  let response = await axios.get(baseURL + "/api/active-job-titles");
  return response.data;
}
  // List of Active Genders
export const get_all_active_genders = async () => {
  let response = await axios.get(baseURL + "/api/get-active-genders");
  return response.data;
}
  // List of Nationalities
export const get_all_nationalities= async () => {
    let response = await axios.get(baseURL + "/api/nationality");
    return response.data;
  }
    // List of Nationalities
export const get_all_nationalities_active= async () => {
  let response = await axios.get(baseURL + "/api/active-nationalities");
  return response.data;
}
    // List of Martial Status
export const get_all_martial_status= async () => {
    let response = await axios.get(baseURL + "/api/marital-status");
    return response.data;
  }
      // List of Active Martial Status
export const get_all_active_martial_statuses= async () => {
  let response = await axios.get(baseURL + "/api/active-marital-statuses");
  return response.data;
}
  // Add User
export const add_user_emlpoyee = async (formData:object) => {
    const response = await axios.post(baseURL + "/api/user", formData);
    return response.data;
};
// Add New Dependent
export const add_employee_dependents = async (values: AddDependentModel) => {
  let response = await axios.post(`${baseURL}/api/employee-dependents`, values);
  return response.data;
}
// List of Dependent
export const get_all_employee_dependents = async () => {
 const current_employee= localStorage.getItem("current_user_id")
  let response = await axios.get(`${baseURL}/api/employee-dependents/${current_employee}`);
  return response.data;
}
// Delete Dependent
export const delete_employee_dependents = async (id: number) => {
  let response = await axios.delete(`${baseURL}/api/employee-dependents/${id}`);
  return response.data;
}
// Update Dependent
export const update_employee_dependents = async (id: number,  values: AddDependentModel) => {
  let response = await axios.patch(`${baseURL}/api/employee-dependents/${id}`, values);
  return response.data;
}
//dependant logs
export const get_single_employee_dependents_logs = async (id) => {
  let response = await axios.get(`${baseURL}/api/employee-dependent-activity-log/${id}`);
  return response.data;
}
// Add New Employee Skill
export const add_employee_skills = async (values: AddEmployeeSkillModel) => {
  let response = await axios.post(`${baseURL}/api/employee-skills`, values);
  return response.data;
}
// List of Employee Skill
export const get_all_employee_skills = async (id) => {
  let response = await axios.get(`${baseURL}/api/employee-skills-against-id/${id}`);
  return response.data;
}
// Delete Employee Skill
export const delete_employee_skills = async (id: number) => {
  let response = await axios.delete(`${baseURL}/api/employee-skills/${id}`);
  return response.data;
}
// Update Employee Skill
export const update_employee_skills = async (id: number,  values: AddEmployeeSkillModel) => {
  let response = await axios.patch(`${baseURL}/api/employee-skills/${id}`, values);
  return response.data;
}
//skill logs
export const get_single_employee_skills_logs = async (id) => {
  let response = await axios.get(`${baseURL}/api/employee-skill-log/${id}`);
  return response.data;
}
export const get_all_employee_skills_logs = async (id) => {
  let response = await axios.get(`${baseURL}/api/employee-skill-logs-by-employee-id/${id}`);
  return response.data;
};
// Add New Employee Supervisor
export const add_employee_supervisors = async (values: AddEmployeeSupervisorModel) => {
  let response = await axios.post(`${baseURL}/api/employee-supervisors`, values);
  return response.data;
}
// List of Employee Supervisor
export const get_all_employee_supervisors = async () => {
  let response = await axios.get(`${baseURL}/api/employee-supervisors`);
  return response.data;
}
// Delete Employee Supervisor
export const delete_employee_supervisors = async (id: number) => {
  let response = await axios.delete(`${baseURL}/api/employee-supervisors/${id}`);
  return response.data;
}
// Update Employee Supervisor
export const update_employee_supervisors = async (id: number,  values: AddEmployeeSupervisorModel) => {
  let response = await axios.patch(`${baseURL}/api/employee-supervisors/${id}`, values);
  return response.data;
}
export const get_employee_supervisor_logs = async (id) => {
  let response = await axios.get(`${baseURL}/api/employee-supervisors-log-by-id/${id}`);
  return response.data;
}
// Add New Education
export const add_education = async (values: AddEducationQualificationModel) => {
  let response = await axios.post(`${baseURL}/api/education`, values);
  return response.data;
}
// List of Education
export const get_all_education = async () => {
  let response = await axios.get(`${baseURL}/api/education`);
  return response.data;
}
// List of Education
export const get_single_education = async (id) => {
  let response = await axios.get(`${baseURL}/api/user/${id}/educations`);
  return response.data;
}
// Delete Education
export const delete_education = async (id: number) => {
  let response = await axios.delete(`${baseURL}/api/education/${id}`);
  return response.data;
}
// Update Education
export const update_education = async (id: number,  values: AddEducationQualificationModel) => {
  let response = await axios.patch(`${baseURL}/api/education/${id}`, values);
  return response.data;
}
//education logs
export const get_single_employee_education_logs = async (id) => {
  let response = await axios.get(`${baseURL}/api/single-education-log/${id}`);
  return response.data;
}
export const get_all_employee_education_logs = async (id) => {
  let response = await axios.get(`${baseURL}/api/education-logs-by-employee-id/${id}`);
  return response.data;
};
// Add New employee-licenses
export const add_employee_licenses = async (values: AddEmployeeLicensesModel) => {
  let response = await axios.post(`${baseURL}/api/employee-licenses`, values);
  return response.data;
}
// List of employee-licenses
export const get_all_employee_licenses = async (id) => {
  let response = await axios.get(`${baseURL}/api/employee-licenses-against-id/${id}`);
  return response.data;
}
// Delete employee-licenses
export const delete_employee_licenses = async (id: number) => {
  let response = await axios.delete(`${baseURL}/api/employee-licenses/${id}`);
  return response.data;
}
// Update employee-licenses
export const update_employee_licenses = async (id: number,  values: AddEmployeeLicensesModel) => {
  let response = await axios.patch(`${baseURL}/api/employee-licenses/${id}`, values);
  return response.data;
}
//license logs
export const get_single_employee_license_logs = async (id) => {
  let response = await axios.get(`${baseURL}/api/single-employee-licenses-log/${id}`);
  return response.data;
}
export const get_all_employee_license_logs = async (id) => {
  let response = await axios.get(`${baseURL}/api/employee-licenses-activity-logs-by-employee-id/${id}`);
  return response.data;
};
//license logs
export const get_single_employee_personal_details_logs = async (id) => {
  let response = await axios.get(`${baseURL}/api/employee-personal-details-activity-log/${id}`);
  return response.data;
}
